var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{staticClass:"sendverification",attrs:{"native-type":"button","disabled":_vm.isSend,"size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.ckvcode('domform')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }